/**
 * The only reason this composable exists is so we can move the Pro controls to their own dynamic bundle.  (235k)
 * Vite (Rollup) is supposed to support tree shaking dynamic imports, but this chunks seems much larger than expected.  CreateProPlugin alone seems to be 158k, shrug.
 */
export default async function () {
  const { createProPlugin, mask } = await import('@formkit/pro')
  return { proPlugin: createProPlugin('fk-700dce0115', { mask }) }
}
